import Choices from 'choices.js';

export default function () {
  document.addEventListener('alpine:init', () => {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll<HTMLElement>('[data-choices]').forEach(input => {
        // @ts-ignore
        input.choices = new Choices(input, {
          removeItemButton: true,
          searchFields: 'value',
          itemSelectText: 'Auswählen',
          noResultsText: 'Keine Ergebnisse …',
          noChoicesText: 'Keine Auswahl …',
          fuseOptions: {},
        });
      });
    });
  });
}
